export function mobileNav() {
    const body = $("body");
    const btnMenu = $(".btn-menu");
    const mainNav = $('.header-menu');
    const mainNavItems = mainNav.find('.has-children');

    const arrowButton = `<button class="arrow-button">
                            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2 2L6 6L10 2" stroke="#202122" stroke-width="1.5" stroke-linecap="square"/>
                            </svg>
                        </button>`;

    const backButton = `<div class="back">
						  <button>Back to Menu</button>
						  <span></span>
					    </div>`;
    let activeMenuItem;

    btnMenu.on("click", function (e) {
        let $this = $(this);
        if (!$this.hasClass("open")) {
            $this.addClass("open");
            $this.text("Close");
            body.addClass("menu-opened");
        } else {
            $this.removeClass("open");
            $this.text("Menu");
            body.removeClass("menu-opened");
        }
        $('.header-search').removeClass('search-active');
        $('.open-search-button').removeClass('active');
        e.preventDefault();
    });

    //append back button
    mainNavItems.each((i, item) => {
        const menuList = $(item).find(' > .sub-menu');
        if (!$(item).find('.arrow').length) {
            $(arrowButton).insertBefore(menuList, null);
            $(menuList).prepend(backButton);
        }
    });

    //close menu
    function closeDropdown(e) {
        if (!mainNavItems.has(e.target).length > 0) {
            mainNavItems.removeClass('active');
            window.removeEventListener('click', closeDropdown);
        }
    }

    //show/hide menu
    $(document).on("click", mainNav, function (e) {
        const target = $(e.target);

        if (target.closest('.has-children > .arrow-button, .has-children > strong, .login-holder .button').length) {
            e.preventDefault();
            activeMenuItem = target.closest('.has-children');
            const activeMenuItemText = activeMenuItem.find('> a, > strong').text();
            activeMenuItem.find('.back span').text(activeMenuItemText);
            if (body.hasClass('touch') || window.innerWidth < 1200) {
                if (!activeMenuItem.hasClass("active")) {
                    activeMenuItem.siblings().removeClass('active');
                    activeMenuItem.addClass("active");
                    window.addEventListener('click', closeDropdown);
                } else {
                    activeMenuItem.removeClass("active");
                    window.removeEventListener('click', closeDropdown);
                }
            } else {
                if (activeMenuItem.hasClass('login-holder')) {
                    activeMenuItem.toggleClass('active');
                }
            }
        }

        if (target.closest('.back button').length) {
            $('.has-children').removeClass('active');
            activeMenuItem.removeClass("active");
            activeMenuItem = activeMenuItem.closest('.has-children.active');
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js